import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/components/theme-provider";

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  const { resolvedTheme } = useTheme();
  return (
    <Sonner
      theme={resolvedTheme}
      position="top-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast bg-surface text-ink-900 border border-line shadow-md",
          description: "text-ink-500",
          actionButton: "bg-p-600 text-white",
          cancelButton: "bg-surface-1 text-ink-700",
        },
      }}
      {...props}
    />
  );
}
